import { CircleCheck, CircleX } from "lucide-react";
import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { PageHeader } from "../components";
import { useAppData } from "../context";

export function OAuthResult({ success }: { success: boolean }) {
  const [params] = useSearchParams();
  const { refresh } = useAppData();
  useEffect(() => { if (success) void refresh(); }, [refresh, success]);
  const accountCode = params.get("account_code");
  const reason = params.get("reason");

  return <>
    <PageHeader eyebrow="ACCOUNTS / OAUTH" title={success ? "Mercado Libre 授权成功" : "Mercado Libre 授权失败"} />
    <section className={`workspace-band oauth-result ${success ? "success" : "error"}`}>
      {success ? <CircleCheck size={34} /> : <CircleX size={34} />}
      <div><strong>{success ? `${accountCode ?? "店铺"} 已完成授权` : "授权未完成"}</strong><span>{success ? "账号身份与 Token 已安全保存。" : `错误代码：${reason ?? "UNKNOWN"}`}</span></div>
      <Link className="button primary" to="/accounts">返回账号管理</Link>
    </section>
  </>;
}
